import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import {  FaUserEdit } from "react-icons/fa";
import { getDecryptedData } from "../config/crypto";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "../components/Loader";
import { useNavigate } from "react-router";

const EditProfile = (props) => {
  const navigate = useNavigate()
  const [data, setData] = useState({});
  const [apiIsLoading, setApiIsLoading] = useState(false);
  const [banner, setBanner] = useState(null);
  const [bannerFile, setbannerFile] = useState([]);
  const [profile, setProfile] = useState(null);
  const [profileFile, setprofileFile] = useState(null);
  const [error,setError] = useState(null)
  const fileInputRef = useRef(null);
  const profileInputRef = useRef(null)
  useEffect(() => {
    const getData = async () => {
      try {
        setApiIsLoading(true);
        const token = getDecryptedData("token");
        const res = await axios.get(`${REACT_APP_API_PORT}user/auth/getprofile`, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        });
        setApiIsLoading(false);
        if (res.data.status) {
          setData(res.data.data);
        }
      } catch (err) {
        setApiIsLoading(false);
        console.log(err);
      }
    };
    getData();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      about: data.about || "",
      gender: data.gender || "",
      email: data.email || "",
      number: data.phone || "",
      password: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      about: Yup.string().min(5).max(350),
      gender: Yup.string().required("Gender is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      number: Yup.string()
        .matches(/^\d{10}$/, "Must be a valid 10-digit number")
        .required("Number is required"),
      password: Yup.string().min(6, "Password must be at least 6 characters").max(20),
    }),
    onSubmit: async (values) => {

      try {
        const formData = new FormData();

        formData.append("name", values.name);
        formData.append("phone", values.number);
        formData.append("gender", values.gender);
        formData.append("about", values.about);
        if (values.password) {
          formData.append("password", values.password);
        }

        if (bannerFile) {
          formData.append("banner", bannerFile); // Append banner image
        }

        if (profileFile) {
          formData.append("image", profileFile); // Append profile image
        }

        console.log("FormData Entries:", [...formData.entries()]); // Debugging output

        const token = getDecryptedData("token");
        setApiIsLoading(true);

        const res = await axios.post(`${REACT_APP_API_PORT}user/auth/updateprofile`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": token,
          },
        });

        setApiIsLoading(false);

        if (res.data.status) {
          props.setAlertBox(true);
          props.showAlert(res.data.message, "success");
          navigate('/my-profile')
        }
      } catch (err) {
        setApiIsLoading(false);
        console.error(err);
        if (err.response?.data?.status === false) {
          props.setAlertBox(true);
          props.showAlert(err.response.data.message, "error");
        }
      }
    }

  });


  const handleProfileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setprofileFile(file)
      if (file.size > 5 * 1024 * 1024) {
        alert("File size should not exceed 5MB.");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerProfileInput = () => {
    if (profileInputRef.current) {
      profileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        setError("Only PNG, JPG, and JPEG formats are allowed.");
        return;
      }
  
      if (file.size > 5 * 1024 * 1024) {
        setError("File size should not exceed 5MB.");
        return;
      }
  
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width !== 1292 || img.height !== 250) {
          setError("Image dimensions must be 1292x250 pixels.");
          return;
        }
        
        setbannerFile(file);
        setBanner(img.src);
        setError(null)
      };
    }
  };
  
  return (
    <>
      <Loader isLoading={apiIsLoading} />
      {/* <TopBar /> */}
      <Header />
      <div className="flex justify-center items-center bg-black text-white pb-12 px-6 pt-32 ">
        <div className="grid border border-gray-500 rounded-xl gap-4 container mx-auto px-6 py-6 max-w-[80rem] ">
          <form onSubmit={formik.handleSubmit}>
         

            <div className="flex  mb-6">
              <div className="border border-gray-700 rounded-full h-28 w-28 md:h-32 md:w-32 lg:h-40 lg:w-40 xl:h-48 xl:w-48 bg-gray-300 relative">
                {profile ?
                  <img src={profile} alt="Banner" className="w-full h-full object-cover rounded-full" />
                  :
                  <>
                    {
                      (data?.image) ?
                        <img src={IMAGE_URL + data.image || '/default.jpeg'} alt="Banner" className="w-full h-full object-cover rounded-full" />
                        :
                        <img src={'/default.jpeg'} alt="Banner" className="w-full h-full object-cover rounded-full" />
                    }
                  </>
                }
                <input
                  accept="image/*"
                  type="file"
                  ref={profileInputRef}
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={handleProfileUpload}
                />
                <div onClick={triggerProfileInput} className="rounded-full w-9 h-9 flex justify-center items-center absolute right-2 bottom-2 bg-white border border-gray-300 shadow-md">
                  <FaUserEdit className="text-black w-5 h-5" />
                </div>
              </div>
            </div>
            <div className="grid gap-4">
              <div>
                <label htmlFor="name" className="text-sm">Name</label>
                <input type="text" id="name" {...formik.getFieldProps("name")} className="w-full h-10 bg-black text-white border border-gray-500 rounded-xl px-3 py-2" />
                {formik.touched.name && formik.errors.name && <p className="text-red-500 text-sm">{formik.errors.name}</p>}
              </div>

              <div>
                <label htmlFor="about" className="text-sm">About</label>
                <textarea id="about" rows="5" {...formik.getFieldProps("about")} className="w-full bg-black text-white border border-gray-500 rounded-xl p-2"></textarea>
                {formik.touched.about && formik.errors.about && <p className="text-red-500 text-sm">{formik.errors.about}</p>}
              </div>

              <div>
                <label className="text-sm">Gender</label>
                <div className="flex gap-6 my-2">
                  <label>
                    <input type="radio" name="gender" value="Male" onChange={formik.handleChange} checked={formik.values.gender === "Male"} /> Male
                  </label>
                  <label>
                    <input type="radio" name="gender" value="Female" onChange={formik.handleChange} checked={formik.values.gender === "Female"} /> Female
                  </label>
                </div>
                {formik.touched.gender && formik.errors.gender && <p className="text-red-500 text-sm">{formik.errors.gender}</p>}
              </div>

              <div>
                <label htmlFor="email" className="text-sm">Email</label>
                <input readOnly type="email" id="email" {...formik.getFieldProps("email")} className="w-full h-10 bg-black text-white border border-gray-500 rounded-xl px-3 py-2" />
                {formik.touched.email && formik.errors.email && <p className="text-red-500 text-sm">{formik.errors.email}</p>}
              </div>

              <div>
                <label htmlFor="number" className="text-sm">Number</label>
                <input type="text" id="number" {...formik.getFieldProps("number")} className="w-full h-10 bg-black text-white border border-gray-500 rounded-xl px-3 py-2" />
                {formik.touched.number && formik.errors.number && <p className="text-red-500 text-sm">{formik.errors.number}</p>}
              </div>

              <div>
                <label htmlFor="password" className="text-sm">Update Password</label>
                <input type="password" id="password" {...formik.getFieldProps("password")} className="w-full h-10 bg-black text-white border border-gray-500 rounded-xl px-3 py-2" />
                {formik.touched.password && formik.errors.password && <p className="text-red-500 text-sm">{formik.errors.password}</p>}
              </div>
            </div>
            <div className="flex justify-end">
              <button type="submit" className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition font-bold uppercase mt-6">Save</button>
            </div>
          </form>
        </div>
      </div>
      <CallToAction />
      <Footer />
    </>
  );
};

export default EditProfile;
